import {forwardRef, useId} from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import clsx from 'clsx';

import {TextareaProps} from '~/common/Form/types';

import s from './styles.module.scss';

/**
 * @deprecated This component is deprecated. Use FormTextArea instead.
 */
const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({error, className, placeholder, value, onChange, label, required, ...rest}, ref) => {
    const id = useId();

    return (
      <div className={clsx('input', s['input-textarea'], {[s.error]: error}, className)}>
        {label && (
          <div className={s['label-content-textarea']}>
            <label htmlFor={`textarea_${id}`}>
              {label} {required && <span>*</span>}
            </label>
          </div>
        )}

        <div className={clsx('input-container-textarea')}>
          <TextareaAutosize
            id={`textarea_${id}`}
            ref={ref}
            className={clsx(s.textarea, className)}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            {...rest}
          />
        </div>

        {error && (
          <div className={s['info-textarea']}>
            <span className={s['error-message-textarea']}>{error}</span>
          </div>
        )}
      </div>
    );
  }
);

export default Textarea;
